import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/magic.ai/frontend/magicsquare/apps/store-web/components/pages/StoryPage/SpecificStory/5tarsCampaignStory/5tarsCampaignStory.tsx");
